import * as React from "react";
import { BrComponent } from "@bloomreach/react-sdk";
import { generateConditionalClassNames, removeWhiteSpaceChars } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css         */
const CmsRow = ({ component }) => {
  const { showInDesktop, showInTablet, showInPhone, fullWidth, tabButtonTitle, ...cssStyles } = component.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const rowClassName = generateConditionalClassNames("br-row", {
    fullWidth,
    showInDesktop,
    showInTablet,
    showInPhone
  });
  const idValue = tabButtonTitle ? removeWhiteSpaceChars(`rowTabPanel-${tabButtonTitle}`) : void 0;
  const ariaLabelledByValue = tabButtonTitle ? removeWhiteSpaceChars(`rowTabButton-${tabButtonTitle}`) : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: rowClassName,
      "data-t": "br-row",
      style: { ...filteredStyles },
      ...idValue && { id: idValue },
      ...ariaLabelledByValue && { "aria-labelledby": ariaLabelledByValue }
    },
    /* @__PURE__ */ React.createElement(BrComponent, null)
  );
};
export {
  CmsRow,
  CmsRow as default
};
//# sourceMappingURL=Row.js.map
